<template>
  <div class="header">
    <div class="left">
      <a class="logo-container" href="https://admin.marveltyres.com.au/#/quotings">
        <img class="logo-img" src="../assets/navlogo.png" />
      </a>
      <div class="menu-btn-container">
        <header-express-drop-down-btn class="header-btn"></header-express-drop-down-btn>
        <header-self-order-btn class="header-btn"></header-self-order-btn>
      </div>
    </div>
    <div class="right">
      <el-dropdown @command="handleCommand">
        <span class="text">
          <i class="el-icon-user-solid"></i>
          &nbsp;{{name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="personal-opration">
          <el-dropdown-item command="changePassword">Change Password</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog title="Change Password" :visible.sync="passwordVisible" width="40%">
        <el-form :model="password" label-width="120px" class="password-change">
          <el-form-item label="New Password" class="pass-input">
            <el-input type="password" v-model="password.password"></el-input>
          </el-form-item>
          <el-form-item label="Confirm Password" class="pass-input">
            <el-input type="password" v-model="password.confirm"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="passwordVisible = false">Cancel</el-button>
          <el-button type="primary" @click="handleChangePassword">Submit</el-button>
        </span>
      </el-dialog>
      <header-swt-org></header-swt-org>
      <div class="divider"></div>
      <header-logout></header-logout>
    </div>
  </div>
</template>

<script>
import HeaderExpressDropDownBtn from './HeaderExpressDropDownBtn'
import HeaderSelfOrderBtn from './HeaderSelfOrderBtn'
import HeaderSwtOrg from './HeaderSwtOrg'
import HeaderLogout from './HeaderLogout'
import { mapGetters } from 'vuex'
import { changePassword } from '../api'

export default {
  name: 'AppHeader',
  components: {
    HeaderExpressDropDownBtn,
    HeaderSelfOrderBtn,
    HeaderSwtOrg,
    HeaderLogout
  },
  computed: {
    ...mapGetters({
      name: 'currentName',
      orgId: 'currentOrgId',
      orgName: 'currentOrgName'
    })
  },
  data () {
    return {
      passwordVisible: false,
      password: {
        password: '',
        confirm: ''
      }
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'changePassword') {
        this.passwordVisible = !this.passwordVisible
      }
    },
    async handleChangePassword () {
      if (this.password.password === '') {
        this.$message({
          message: 'Password can not be empty',
          type: 'error'
        })
        return
      }

      if (this.password.password !== this.password.confirm) {
        this.$message({
          message: 'Confirm Password is not the same',
          type: 'error'
        })
        return
      }
      await changePassword(this.password.password)
      this.passwordVisible = false
      this.$message({
        message: 'Password has been changed successfully',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: #231F20;
  box-shadow: 2px 2px 2px rgb(195, 195, 195);
}
.left {
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 30px;
  gap: 24px;
}
.logo-container {
  height: 100%;
  display: flex;
  align-items: center;
}
.logo-img {
  width: 140px;
}
.menu-btn-container {
  margin: 0 8px;
}
.header-btn {
  display: inline-block;
  flex: 0 0 auto;
  margin-right: 16px;
}
.right {
  height: 100%;
  display: flex;
  margin-right: 12px;
  align-items: center;
  justify-content: space-around;
}
.text {
  color: rgb(200, 200, 200);
  margin-right: 16px;
  font-size: 13px;
}
.divider {
  display: inline-block;
  background-color: #fff;
  width: 1px;
  height: 24px;
  margin: 0 8px;
  vertical-align: middle;
}
.personal-opration {
  width: 200px;
}
.password-change {
  margin: 5px auto;
  width: 400px;
  .pass-input {
    margin-top: 10px !important;
  }
}
</style>
